import { styled } from '@mui/material';

import { Typography } from '@app-velocity/ui';

import { PathPreview } from '../../../../components/PathPreview';
import { SinglePath } from '../../../../types';

const StyledPathsSection = styled('div')(({ theme }) => ({
  padding: `${theme.spacing(5)} 0`,
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(5),
}));

const StyledTitle = styled(Typography)(({ theme }) => ({
  fontSize: 16,
  fontWeight: 700,
}));

const PathsList = styled('ul')(({ theme }) => ({
  padding: 0,
  margin: 0,
  listStyleType: 'none',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(5),
}));

export type PathsSectionProps = {
  paths: SinglePath[];
  title: string;
  subtitle: string;
  secondary?: boolean;
  indexOffset?: number;
};

export const PathsSection = ({
  paths,
  title,
  subtitle,
  secondary,
}: PathsSectionProps) => {
  return (
    <StyledPathsSection>
      <header>
        <StyledTitle component={secondary ? 'h4' : 'h3'}>{title}</StyledTitle>
        <Typography>{subtitle}</Typography>
      </header>
      <PathsList>
        {paths.map((path, index) => (
          <li key={path.id}>
            <PathPreview path={path} secondary={secondary} />
          </li>
        ))}
      </PathsList>
    </StyledPathsSection>
  );
};
